import { repositionGraph as d3Hierarchy } from './d3hierarchy';
import { Edge, LAYOUT_ALGO } from './layoutTypes';
import { repositionGraph as original } from './reposition';

export const repositionGraph = ({
  algo,
  nodes,
  edges,
  yMax,
  xMax,
}: {
  algo: LAYOUT_ALGO;
  nodes: string[];
  edges: Edge[];
  xMax: number;
  yMax: number;
}) => {
  switch (algo) {
    case 'd3':
      return d3Hierarchy({ nodes, edges, xMax, yMax });
    case 'orig':
      return original({ nodes, edges, xMax, yMax });
    case 'default':
    default:
      return d3Hierarchy({ nodes, edges, xMax, yMax });
  }
};
